export const flagStatuses = {
  IN_PROGRESS: "In progress",
  COMPLETED: "Completed",
  ESCALATED: "Escalated",
  PENDING: "Pending",
  CREATED: "Created",
  ACTIVATED: "Activated",
  NOT_ACTIVATED: "Not activated",
  DEACTIVATED: "Deactivated",
};

export const reportsTypes = {
  SINGLE: "Single",
  MULTI: "Multy",
  DAILY: "Daily",
};

export const resolutionStatuses = {
  DOCUMENT_ENQUIRY: "Document Enquiry",
  FOR_INVESTIGATION: "For Investigation",
  FALSE_POSITIVE: "False Positive",
  CUSTOMER_WARNING: "Customer Warning",
  TERMINATION_OF_CONTRACT: "Termination of the Contract",
  STOP_OPERATION: "Stop the Operation",
  FOR_REPORTING: "For Reporting",
  FOR_MONITORING: "For Monitoring",
  INCREASEDRISK: "Increased Risk",
  DECREASEDRISK: "Decreased Risk",
  RED_FLAG: "Red Flag",
  TRANSACTION_ALLOWED: "Transaction Allowed",
  PROHIBITED: "Prohibited",
};

export const reportsLabels = {
  SINGLE: "Single",
  MULTI: "Multi",
  DAILY: "Daily",
  FOR_MONITORING: "For monitoring",
};

export const conditionalIntervals = {
  DAY_BEFORE_NOW: "Days before now",
  MONTH_BEFORE_NOW: "Months before now",
  YEAR_BEFORE_NOW: "Years before now",
};

export const conditionalIntervalsPlural = {
  DAY_BEFORE_NOW: "Days before now",
  MONTH_BEFORE_NOW: "Months before now",
  YEAR_BEFORE_NOW: "Years before now",
};

export const rolesLabels = {
  GRANT_ADMIN: "Grant admin",
  ADMIN: "Admin",
  AML_CORDINATOR: "Backoffice specialist 1st level",
  AML_MANAGER: "Backoffice specialist 2nd level",
  AUDITOR: "Auditor",
  CUSTOMER_SUPPORT: "Customer support",
};

export const toastDisplayTime = 10000;

export const statusColorClasses = {
  PENDING: "status-red",
  IN_PROGRESS: "status-orange",
  COMPLETED: "status-green",
  ESCALATED: "status-orange",
};

export const errorMsg = "Something happened. Try again later.";

export const rulesOrderSelectors = {
  dateCreated: "DATE",
  author: "AUTHOR",
  name: "RULE_NAME",
  status: "STATUS",
  typeOfRule: "RULE_TYPE",
  period: "PERIOD",
  periodCount: "PERIOD_COUNT",
};

export const ruleFilterSelectors = {
  name: "ruleName",
  dateCreated: "dateCreated",
  author: "author",
  status: "status",
  typeOfRule: "typeOfRule",
  period: "period",
  periodCount: "periodCount",
};

export const flagAdvancedSearchSelectors = {
  id: "id",
  name: "ruleName",
  date: "date",
};

export const monitoringQueueOrderSelectors = {
  date: "DATE",
  name: "RULE_NAME",
  data: "RULE_DATA",
  tenant: "ORGANIZATION",
  assignee: "ASSIGNEE",
  resolution: "RESOLUTION",
  status: "STATUS",
  id: "ID",
  personNames: "PERSON_NAMES", // client name
  contractIdentifier: "CONTRACT_IDENTIFIER", // kid
};

export const monitoringQueueFilterSelectors = {
  id: "id",
  name: "ruleName",
  contractIdentifier: "contractIdentifier",
  personNames: "personNames",
  locked: "locked",
  data: "ruleData",
  tenant: "organization",
  assignee: "assignee",
  resolution: "resolution",
  status: "status",
};

export const forMonitoringFilterSelectors = {
  flagId: "flagId",
  assignee: "assignee",
  resolution: "resolutionStatus",
  executionCheck: "executionCheck",
  tenant: "tenant",
};

export const onlyWhiteSpaceRegex = /^\s*$/;

export const periodItems = [
  { value: "DAY", label: "Day" },
  { value: "WEEK", label: "Week" },
  { value: "MONTH", label: "Month" },
];

export const rulesTableTypes = {
  CUSTOM: "custom",
  BASIC: "basic",
};

export const routes = {
  MONITORING_QUEUE: "/monitoring",
  CASES_FOR_MONITORING: "/reports/reports-for-monitoring",
};

export const dateFilterOperations = ["=", "<", ">", "between", "clear"];

export const SORT_DIRECTION = {
  ASC: "ASC",
  DESC: "DESC",
};
